import { render, staticRenderFns } from "./Foyer.vue?vue&type=template&id=9757be06&scoped=true&"
import script from "./Foyer.vue?vue&type=script&lang=ts&"
export * from "./Foyer.vue?vue&type=script&lang=ts&"
import style0 from "./Foyer.vue?vue&type=style&index=0&id=9757be06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9757be06",
  null
  
)

export default component.exports